import { generateId } from '@/features/quote-and-apply-builder';

export function createNewSection(title: string = 'New Section'): PolicyFormSection {
  const id = generateId('section');
  return {
    id,
    title,
    subsections: [],
  };
}

export function createNewSubsection(title: string = 'New Subsection'): PolicyFormSubSection {
  const id = generateId('subsection');
  return {
    id,
    title,
    questionGroups: [],
  };
}

export function createNewGroup(title: string = ''): PolicyFormQuestionGroup {
  const id = generateId('group');
  return {
    id,
    title,
    format: 'default',
    questions: [],
  };
}

export function createNewQuestion(
  questionRef: string,
  title: string,
  type: PolicyFormQuestion['type'] = 'text',
): PolicyFormQuestion {
  const id = generateId('question');
  return {
    id,
    questionRef,
    title,
    type,
    required: false,
  };
}

export function countTotalQuestions(formDefinition: PolicyFormDefinition): number {
  return Object.keys(formDefinition.questions).length;
}
